import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize, map, Observable } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { Generic } from 'src/app/interfaces/generic.interface';
import { DocumentTypeService } from '../document-type.service';
import { DocumentTypeAddPayload } from '../document-type.interface';
import { CommonService } from 'src/app/services/common.service';
import { DocumentStatusesService } from '../../document-statuses/document-statuses.service';
import { DocumentPrioritiesService } from '../../document-priorities/document-priorities.service';

@Component({
    selector: 'app-add-document-type',
    templateUrl: './add-document-type.component.html',
    styleUrls: ['./add-document-type.component.scss']
})
export class AddDocumentTypeComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    directiiActive$!: Observable<Generic[]>;
    compartimenteActive$!: Observable<Generic[]>;
    usersActive$!: Observable<Generic[]>;
    statusesActive$!: Observable<Generic[]>;
    prioritiesActive$!: Observable<Generic[]>;

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        slug: new FormControl('', [Validators.required]),
        status_id: new FormControl('', [Validators.required, Validators.min(0)]),
        priority_id: new FormControl('', [Validators.required, Validators.min(0)]),
        // directie_id: new FormControl('', [Validators.required, Validators.min(0)]),
        // compartiment_id: new FormControl(null, []),
        user_id: new FormControl(null, []),
    });

    constructor(
        private dialogRef: MatDialogRef<AddDocumentTypeComponent>,
        private requestService: DocumentTypeService,
        private commonService: CommonService,
        private documentStatusesService: DocumentStatusesService,
        private documentPrioritiesService: DocumentPrioritiesService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() {
        // this.loadDirectiiActive();
        this.loadUsers();
        this.loadStatusuriDocumenteActive();
        this.loadPrioritatiDocumenteActive();
    }

    // loadDirectiiActive() {
    //     this.isLoading = true;
    //     this.directiiActive$ = this.commonService.getDirectiiActive().pipe(
    //         map((results: any) => [this.defaultParameter, ...results]),
    //         finalize(() => (this.isLoading = false))
    //     );
    // }

    // onDirectieChange(directieId: number): void {
    //     if (directieId) {
    //         this.loadCompartimenteActive(directieId);
    //         this.loadUsersActive();
    //     } else {
    //         this.compartimenteActive$ = new Observable<Generic[]>((observer) => {
    //             observer.next([{ name: '--Alegeți--', id: -1 }]);
    //             observer.complete();
    //         });
    //     }
    // }

    // loadCompartimenteActive(directieId?: number) {
    //     this.isLoading = true;
    //     let compartimenteObservable$ = directieId
    //         ? this.commonService.getCompartimenteByDirectieId(directieId)
    //         : this.commonService.getCompartimenteActive();

    //     this.compartimenteActive$ = compartimenteObservable$.pipe(
    //         map((results: any) => [this.defaultParameter, ...results]),
    //         finalize(() => {
    //             this.isLoading = false;
    //         })
    //     );
    // }

    // onDirectieCompartimentChange(): void {
    //     this.loadUsersActive();
    // }

    // loadUsersActive() {
    //     this.isLoading = true;
    //     this.usersActive$ = this.commonService
    //         .getUsersByOrganigrama(this.form.value)
    //         .pipe(
    //             map((results: any) => [this.defaultParameter, ...results]),
    //             finalize(() => (this.isLoading = false))
    //         );
    // }

    loadUsers() {
        this.isLoading = true;
        this.usersActive$ = this.commonService
            .getUsers()
            .pipe(
                map((results: any) => [this.defaultParameter, ...results]),
                finalize(() => (this.isLoading = false))
            );
    }

    loadStatusuriDocumenteActive() {
        this.isLoading = true;
        this.statusesActive$ = this.documentStatusesService.getListActive().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isLoading = false))
        );
    }

    loadPrioritatiDocumenteActive() {
        this.isLoading = true;
        this.prioritiesActive$ = this.documentPrioritiesService.getListActive().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isLoading = false))
        );
    }

    submitForm() {
        this.isLoading = true;

        const { name, slug, user_id, status_id, priority_id } = this.form
            .value as DocumentTypeAddPayload;
        const payload: DocumentTypeAddPayload = {
            name,
            slug,
            user_id,
            status_id,
            priority_id
        };

        this.requestService
            .storeEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
